export var error = function (msg) {
    throw new Error(msg);
};
//# sourceMappingURL=errors.js.map


// WEBPACK FOOTER //
// ./node_modules/pdf-lib/es/utils/errors.js